// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"6ea1de7b","342":"28a58ea3","509":"28a58ea3","629":"2274b6cf","688":"803a53fd","990":"6ea1de7b"}[chunkId] + ".chunk.css";
};